'use strict';

var React = require('react');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var ListItemIcon = require('../../node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js');
var MenuItem = require('../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var MenuItemWithIcon = function MenuItemWithIcon(props) {
  return React__default["default"].createElement(MenuItem["default"], {
    onClick: function onClick() {
      return props.onTap();
    }
  }, React__default["default"].createElement(ListItemIcon["default"], null, props.icon), React__default["default"].createElement(Typography, null, props.text));
};

module.exports = MenuItemWithIcon;
